var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6501 6.49998C2.6501 4.64982 4.14994 3.14998 6.0001 3.14998H7.60877C8.25402 3.14998 8.8548 3.47876 9.20262 4.02224C9.7894 4.93907 10.8029 5.49373 11.8914 5.49373H14.0001C15.8503 5.49373 17.3501 6.99357 17.3501 8.84373V13.5C17.3501 15.3501 15.8503 16.85 14.0001 16.85H6.0001C4.14994 16.85 2.6501 15.3501 2.6501 13.5V6.49998ZM6.0001 1.84998C3.43197 1.84998 1.3501 3.93185 1.3501 6.49998V13.5C1.3501 16.0681 3.43197 18.15 6.0001 18.15H14.0001C16.5682 18.15 18.6501 16.0681 18.6501 13.5V8.84373C18.6501 6.2756 16.5682 4.19373 14.0001 4.19373H11.8914C11.2462 4.19373 10.6454 3.86494 10.2976 3.32147C9.7108 2.40463 8.6973 1.84998 7.60877 1.84998H6.0001ZM7.0001 13.85C6.64111 13.85 6.3501 14.141 6.3501 14.5C6.3501 14.859 6.64111 15.15 7.0001 15.15H13.0001C13.3591 15.15 13.6501 14.859 13.6501 14.5C13.6501 14.141 13.3591 13.85 13.0001 13.85H7.0001Z",
    fill: "#151F29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9f701dd80de1032408e8fa7362e898f9.svg";
export { ForwardRef as ReactComponent };